import { lazy as reactLazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import { Seo, PageScroll } from "./components/site/Seo";
import { Toaster } from "./components/ui/sonner";
import { REDIRECTS } from "./data/redirects";

const Redirect = ({ to }) => { window.location.replace(to); return null; };

// After a new release old chunk names vanish; retry once, then reload to fetch the fresh build.
const lazy = (load) => reactLazy(() => load().catch(() => new Promise((r) => setTimeout(r, 400)).then(load)).catch((err) => {
  if (!sessionStorage.getItem("chunk-reload")) { sessionStorage.setItem("chunk-reload", "1"); window.location.reload(); return new Promise(() => {}); }
  throw err;
}).then((mod) => { sessionStorage.removeItem("chunk-reload"); return mod; }));
const loadStudio = () => import("./pages/Studio");
const Studio = lazy(loadStudio);
if (typeof window !== "undefined") window.addEventListener("load", () => (window.requestIdleCallback || setTimeout)(loadStudio), { once: true });
const ClerkAuthProvider = lazy(() => import("@/components/auth/ClerkAuthProvider"));
const Admin = lazy(() => import("./pages/Admin"));
const SignInPage = lazy(() => import("./pages/SignInPage"));
const SignUpPage = lazy(() => import("./pages/SignUpPage"));
const TopicPage = lazy(() => import("./pages/TopicPage"));
const CorporateRegistration = lazy(() => import("./pages/CorporateRegistration"));
const About = lazy(() => import("./pages/About"));
const Legal = lazy(() => import("./pages/Legal"));
const ConfirmAppointment = lazy(() => import("./pages/ConfirmAppointment"));
const ChooseSlot = lazy(() => import("./pages/ChooseSlot"));
const Registered = lazy(() => import("./pages/Registered"));

const AuthLayout = () => (
  <ClerkAuthProvider><Outlet /></ClerkAuthProvider>
);

function App() {
  return (
    <BrowserRouter>
      <Seo /><PageScroll /><Toaster position="top-center" richColors />
      <Suspense fallback={<div className="min-h-screen" aria-busy="true" />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/kurse" element={<Studio page="kurse" />} />
        <Route path="/kursplan" element={<Studio page="kursplan" />} />
        <Route path="/coaching" element={<Studio page="coaching" />} />
        <Route path="/preise" element={<Studio page="preise" />} />
        <Route path="/firmenfitness" element={<Studio page="firmenfitness" />} />
        <Route path="/firmenfitness/freischalten" element={<CorporateRegistration />} />
        <Route path="/unternehmen" element={<Studio page="unternehmen" />} />
        <Route path="/ueber-uns" element={<About />} />
        {["hyrox-flensburg", "fitness-fuer-senioren-flensburg", "wiedereinstieg-flensburg", "rueckentraining-flensburg", "yoga-flensburg", "probetraining-flensburg", "abnehmen-flensburg", "krafttraining-frauen-flensburg", "personal-trainer-flensburg"].map((slug) => <Route key={slug} path={`/${slug}`} element={<TopicPage slug={slug} />} />)}
        <Route path="/impressum" element={<Legal page="impressum" />} />
        <Route path="/hausordnung" element={<Legal page="hausordnung" />} />
        <Route path="/datenschutz" element={<Legal page="datenschutz" />} />
        <Route path="/bestaetigen/:id" element={<ConfirmAppointment />} />
        <Route path="/termin-wahl/:id" element={<ChooseSlot />} />
        <Route path="/registriert/:id" element={<Registered />} />
        <Route element={<AuthLayout />}>
          <Route path="/admin" element={<Admin />} />
          <Route path="/sign-in/*" element={<SignInPage />} />
          <Route path="/sign-up/*" element={<SignUpPage />} />
        </Route>
        {Object.entries(REDIRECTS).map(([from, to]) => <Route key={from} path={from} element={<Redirect to={to} />} />)}
        <Route path="*" element={<NotFound />} />
      </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
